import { useContext, ReactNode } from 'react';
import { isEqual } from '@packages/shared/core/common/utils/isEqual';
import { FeatureValue } from '../../entities';
import { FeatureVariationsContext } from '../FeatureVariations';

type VariantProps = {
  value: FeatureValue;
  children: ReactNode;
};

const Variant = ({ children, value }: VariantProps) => {
  const variant = useContext(FeatureVariationsContext);

  if (!isEqual(value, variant)) return null;

  return <>{children}</>;
};

export default Variant;
